export const siteName = "Jet10Line 10’da Bulunur,10’dan Alınır";
export const siteNameUpper = "JET10LINE 10’da Bulunur, 10’dan Alınır";
export const googleStoreUrl =
  "https://play.google.com/store/apps/details?id=com.sanalmarket.jetonline&gl=tr";
export const appleStoreUrl =
  "https://apps.apple.com/tr/app/jet10line-sanal-market/id6502867645";
export const siteMailList = [
  {
    mail: "10linegross@gmail.com",
    subject: "Bize Mail Bırakın ",
  },
];
export const sitePhoneList = [{ phone: "0 (412) 999 18 50", info: "" }];
export const eklenenMiktarKatsayisi = 0.1;
export const siteAddress =  "Mezopotamya Mah. Selahaddin Eyyubi Bul. \n \t    Çeysa Premium Park 95/BB \n \t    Kayapınar/D.BAKIR";

/* ============================================================================================== */
/*                            appstora yonlendirme mesaji ile ilgili                              */
/* ============================================================================================== */
export const askPlatformMessage = true; // yonlendirme sorulacak mi
export const askPlatformCounter = 5; // her kac giriste sorulacak (0 ve 1 icin surekli sorar)
export const useAskNeverButton = false; // bir daha sorma butonu aktif mi
